import * as React from "react";
import { animateScroll } from "react-scroll";

import theme from "@ui/themes/default";

interface Props {
  children?: React.ReactNode;
  init?: () => boolean; // use this prop to dynamically trigger scroll animation
}

export const ScrollToTop = (props: Props): React.ReactElement => {
  const [didAnimate, setDidAnimate] = React.useState(false);

  React.useEffect(() => {
    if (didAnimate) return;
    if (props.init !== undefined && !props.init()) return;

    animateScroll.scrollToTop({
      duration: parseInt(theme.animations.durationLong),
    });

    setDidAnimate(true);
  }, [props.init, didAnimate]);

  return <React.Fragment>{props.children}</React.Fragment>;
};
